/*================= Event Listeners =================*/
    
document.addEventListener("facets:filter_updated", function (e) {
  window.sortByCustom();
  window.updateShowMoreForMobile();
  filterScrollToTop();
});

function filterScrollToTop () {
  setTimeout(function () {
    // Helper to get height of an element if it exists
    function getHeight(selector) {
      const el = document.querySelector(selector);
      return el ? el.offsetHeight : 0;
    }

    const offset =
      getHeight('.header-wrapper') +
      getHeight('.collection-hero') +
      getHeight('.utility-bar');

    window.scrollTo({
      top: offset,
      behavior: 'smooth'
    });
  }, 200);
}

subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
  const { sectionId, html, variant } = data;
  window.currentVariant = variant;
  window.updateBundleVariantImages();
});

/*================= Match Element Height Script =================*/

function matchElementHeights(selector) {
  function adjustHeights() {
    const elements = document.querySelectorAll(selector);
    if (!elements.length) return;

    let maxHeight = 0;

    elements.forEach(el => {
      el.style.height = "auto";
    });

    elements.forEach(el => {
      maxHeight = Math.max(maxHeight, el.offsetHeight);
    });

    elements.forEach(el => {
      el.style.height = `${maxHeight}px`;
    });
  }
  adjustHeights();
  window.addEventListener("resize", adjustHeights);
}
matchElementHeights(".get-your-gains-section .item-heading");
matchElementHeights(".card__content > .card__information .card__heading");
//matchElementHeights(".card__content > .card__information .price-rating-wrapper");

window.sortByCustom = function(){
  const listItems = document.querySelectorAll(".sort_by_options_custom");
  listItems.forEach(item => {
    if(!item.classList.contains("event-added")){
      item.classList.add("event-added");
      const selectOption = function () {
        // Step 1: Handle active class (+ aria-selected for assistive tech)
        listItems.forEach(li => { li.classList.remove("active"); li.setAttribute("aria-selected", "false"); });
        this.classList.add("active");
        this.setAttribute("aria-selected", "true");
  
        // Step 2: Get data-value and apply to closest select
        const value = this.getAttribute("data-value");
        const container = this.closest(".sort_by_custom");
        const select = container.querySelector("select");
  
        if (select) {
          select.value = value;
          if (select) {
            const inputEvent = new Event("input", { bubbles: true, cancelable: true });
            select.dispatchEvent(inputEvent);
          }
        }
      };
      item.addEventListener("click", selectOption);
      // Keyboard: the options are focusable <li role="option"> — Enter/Space selects.
      item.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          selectOption.call(this);
        }
      });
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {

  /*================= Quick Navigation Active Class Script  =================*/

  const quickNav = document.querySelector('.quick-nav-section');

  if (!quickNav) {
    console.warn('Element with class .quick-nav-section not found');
    return;
  }

  window.addEventListener('scroll', () => {
    const rect = quickNav.getBoundingClientRect();
    if (rect.top <= 0) {
      quickNav.classList.add('sticky-quick-nav');
    } else {
      quickNav.classList.remove('sticky-quick-nav');
    }
  });

/*================= Indepedent Test result page  =================*/

  let sortBtns = document.querySelectorAll('.filter-category > *');
  let sortItems = document.querySelectorAll('.filter-item > *');

  for (let i = 0; i < sortBtns.length; i++) {
    sortBtns[i].addEventListener('click', function () {
      sortBtns.forEach(btn => btn.classList.remove('current'));
      this.classList.add('current');

      let targetData = this.getAttribute('data-target');

      sortItems.forEach(item => {
        item.classList.remove('active');
        item.classList.add('delete');

        let itemData = item.getAttribute('data-item');

        if (itemData === targetData || targetData === 'all') {
          item.classList.remove('delete');
          item.classList.add('active');
        }

        // Trigger reflow
        item.offsetHeight;
      });
    });
  }

/*================= Open Cart Drawer after redirection to Home Page from Cart Page =================*/
if (sessionStorage.getItem('cartRedirected') === '1') {
  sessionStorage.removeItem('cartRedirected');
  if (typeof window.upcartOpenCart === 'function') {
      var upcartPoll = setInterval(function() {
      if (typeof window.upcartOpenCart === 'function') {
        window.upcartOpenCart();
        clearInterval(upcartPoll); // Stop polling
      }
    }, 100); // Check every 100ms
  }
}

/*================= Quick Navigation Focus Script =================*/

const activeItem = document.querySelector('.quick-nav-item.is-active');
if (activeItem) {
  activeItem.scrollIntoView({
    behavior: 'smooth',
    inline: 'center', 
    block: 'nearest' 
  });
}

/*================= On Load Executions =================*/
window.sortByCustom();
window.updateBundleVariantImages();

// /*================= Device Recognition Script =================*/

const platform = navigator.platform.toLowerCase();

if (platform.includes("mac")) {
  document.body.classList.add("mac-custom");
} else if (platform.includes("win")) {
  document.body.classList.add("windows-custom");
} else {
  document.body.classList.add("other-os-custom");
}  



const isApple = () => {
  if (navigator.userAgentData) {
    return navigator.userAgentData.platform === "iOS";
  }
  return /Mac|iPhone|iPad|iPod/i.test(navigator.userAgent);
};

if (isApple()) {
  document.body.classList.add("mac-custom");
  document.body.classList.add("ios-custom");
} 


/*================= Product Page FAQ Accordion =================*/
try {
  let faqToggles = [];

  function setupFaqAccordion() {
    faqToggles = document.querySelectorAll('[data-faq-toggle]');

    faqToggles.forEach((toggle) => {
      const content = toggle.nextElementSibling;

      toggle.style.cursor = "pointer";
      content.style.overflow = "hidden";
      content.style.transition = "max-height 0.3s ease";

      if (content.classList.contains("open")) {
        content.style.maxHeight = content.scrollHeight + "px";
      } else {
        content.style.maxHeight = "0px";
      }

      toggle.addEventListener("click", toggle._accordionClick = () => {
        const isOpen = content.classList.contains("open");

        toggle.classList.toggle("active");

        if (isOpen) {
          content.style.maxHeight = "0px";
          content.classList.remove("open");
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
          content.classList.add("open");
        }
      });
    });

    // Delay the initial open to ensure layout is complete
    if (faqToggles.length > 0) {
      setTimeout(() => {
        const firstToggle = faqToggles[0];
        const firstContent = firstToggle.nextElementSibling;

        firstToggle.classList.add("active");
        firstContent.classList.add("open");
        firstContent.style.maxHeight = firstContent.scrollHeight + "px";
      }, 0);
    }
  }

  setupFaqAccordion();
} catch (error) {
  console.error(error);
}

/*================= Footer Accordion =================*/
try {
  let isAccordionActive = false;
  let toggles = [];

  function setupAccordion() {
    toggles = document.querySelectorAll('[data-accordion-toggle]');

    toggles.forEach((toggle) => {
      const content = toggle.nextElementSibling;

      toggle.style.cursor = "pointer";
      content.style.overflow = "hidden";
      content.style.maxHeight = "0px";
      content.style.transition = "max-height 0.3s ease";

      toggle.addEventListener("click", toggle._accordionClick = () => {
        const isOpen = content.classList.contains("open");

        toggle.classList.toggle("active");

        if (isOpen) {
          content.style.maxHeight = "0px";
          content.classList.remove("open");
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
          content.classList.add("open");
        }
      });
    });

    isAccordionActive = true;
  }

  function destroyAccordion() {
    toggles.forEach((toggle) => {
      const content = toggle.nextElementSibling;

      toggle.style.cursor = "";
      toggle.classList.remove("active");
      content.style.maxHeight = "";
      content.style.overflow = "";
      content.style.transition = "";
      content.classList.remove("open");

      if (toggle._accordionClick) {
        toggle.removeEventListener("click", toggle._accordionClick);
        delete toggle._accordionClick;
      }
    });

    isAccordionActive = false;
  }

  function handleResize() {
    if (window.innerWidth < 750 && !isAccordionActive) {
      setupAccordion();
    } else if (window.innerWidth >= 750 && isAccordionActive) {
      destroyAccordion();
    }
  }

  handleResize(); // Initial check
  window.addEventListener("resize", handleResize); // Watch for screen size changes
} catch (error) {
}

/*================= Commonly Stacked Supps Slider Code =================*/
try {
  var swiperContainer = document.querySelector('.stacked-supps-item-wrap');
  
  if (swiperContainer) {
    var Swipes = new Swiper('.stacked-supps-item-wrap', {
      slidesPerView: 'auto',
      navigation: false,
      pagination: false,
      simulateTouch: true,
      grabCursor: true,
      allowTouchMove: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1440: {
          slidesPerView: 4, // 3.65
        },
        1921: {
          slidesPerView: 4, // 3
          spaceBetween: 20,
        }
      }
    });
  } else {

  }
} catch (error) {

}

try {
  const emailInput = document.querySelector("#ContactFooter .newsletter__email");
  const errorMessage = document.querySelector("#ContactFooter #newsletter__Error--message");
  const subscribeBtn = document.querySelector("#Subscribe");

  if (!emailInput || !subscribeBtn) {
    throw new Error("Required DOM elements not found.");
  }

  subscribeBtn.addEventListener("click", function(event) {
    // Reset previous states
    emailInput.classList.remove("error-field");
    errorMessage?.classList.remove("show");
    subscribeBtn.disabled = false;

    const emailValue = emailInput.value.trim();
    const isValid = emailValue && emailValue.includes("@");

    if (!isValid) {
      emailInput.classList.add("error-field");
      errorMessage?.classList.add("show");
      subscribeBtn.disabled = true;
      event.preventDefault();
    }
  });

  emailInput.addEventListener("focus", () => {
    emailInput.classList.remove("error-field");
    errorMessage?.classList.remove("show");
    subscribeBtn.disabled = false;
  });

} catch (error) {
  console.error("Newsletter subscription script error:", error);
}

function applyEventsToMenuItems() {
  const menus = document.querySelectorAll('details.mega-menu');
  menus.forEach((menu) => {
    const summary = menu.querySelector('summary');
    const content = menu.querySelector('.mega-menu__content');
    let isHovering = false;
    let isTouchInteraction = false;

    // Handle touchstart to detect taps
    summary.addEventListener('touchstart', () => {
      isTouchInteraction = true;
    }, { passive: true });

    // Handle click only if it's not hover
    summary.addEventListener('click', (e) => {
      if (isTouchInteraction) {
        // Let native <details> behavior run, but reset touch flag
        isTouchInteraction = false;
        return;
      }
      // Prevent toggle for hover interactions
      e.preventDefault();
      menu.setAttribute('open', true);
    });

    // Hover in/out for mouse users
    summary.addEventListener('mouseenter', () => {
      if (!isTouchInteraction) {
        menu.setAttribute('open', true);
      }
    });

    summary.addEventListener('mouseleave', () => {
      if (!isTouchInteraction) {
        setTimeout(() => {
          if (!isHovering) {
            menu.removeAttribute('open');
          }
        }, 100);
      }
    });

    content.addEventListener('mouseenter', () => {
      isHovering = true;
      if (!isTouchInteraction) {
        menu.setAttribute('open', true);
      }
    });

    content.addEventListener('mouseleave', () => {
      isHovering = false;
      setTimeout(() => {
        if (!menu.querySelector(':hover')) {
          menu.removeAttribute('open');
        }
      }, 100);
    });
  });
}
applyEventsToMenuItems();

/*================= Filter Button on collection page =================*/

const target = document.querySelector(".main__filter--button");
const mobileButton = document.querySelector(".filter-button-mobile");

if (!target || !mobileButton) return;

function isInViewport(element) {
const rect = element.getBoundingClientRect();
return rect.top < window.innerHeight && rect.bottom > 0;
}

// Delay the initial check slightly to ensure layout is calculated
setTimeout(() => {
if (!isInViewport(target)) {
  mobileButton.classList.add("filter--sticky");
} else {
  mobileButton.classList.remove("filter--sticky");
}
}, 50); // You can increase if needed

const observer = new IntersectionObserver(
(entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) {
      mobileButton.classList.add("filter--sticky");
    } else {
      mobileButton.classList.remove("filter--sticky");
    }
  });
},
{ threshold: 0 }
);

observer.observe(target);


});

/*================= Global Functions =================*/

window.updateBundleVariantImages = function(variantId){
if (!window.bundleProduct) return;

let bundleProducts = window.productJSON.metafields.bundle_products;
let variantNotes = window.bundle_products_variants_note || [];
let currentSelectedOptions = [];

// Fill selected options (option1, option2, option3...)
let optionsLength = window.currentVariant.options.length;
for (let i = 1; i <= optionsLength; i++) {
currentSelectedOptions[i - 1] = window.currentVariant[`option${i}`];
}

// Loop through bundle products
for (let i = 0; i < bundleProducts.length; i++) {
let currentBundleProduct = bundleProducts[i];
let selectedOption = currentSelectedOptions[i];

let bundleOptionElement = document.querySelector(`.bundle-product--option-name-${i + 1}`);
let bundleOptionName = currentBundleProduct?.options ? currentBundleProduct.options[0] : null;
if (bundleOptionElement && bundleOptionName) {
  bundleOptionElement.textContent = bundleOptionName;
}

// Find variant in bundle that matches selected option
let matchedVariant = currentBundleProduct.variants.find(
  variant => variant.title === selectedOption
);

// Get product-level featured image as fallback
let productFeaturedImage = currentBundleProduct.featured_image;

// Inject image into corresponding bundle image container
let bundleImageContainer = document.querySelectorAll(".bundle-image-main")[i];
if (bundleImageContainer) {
  let imageContainer = bundleImageContainer.querySelector(".variant-bundle-image");

  if (matchedVariant && matchedVariant.featured_image && matchedVariant.featured_image.src) {
    imageContainer.innerHTML = `
      <img src="${matchedVariant.featured_image.src}" width="" height="" alt="${matchedVariant.title}">
    `;
  } else if (productFeaturedImage) {
    imageContainer.innerHTML = `
      <img src="${productFeaturedImage}" width="100" height="100" alt="${currentBundleProduct.title}">
    `;
  } else {
    imageContainer.innerHTML = `<p>No matching image available</p>`;
  }
}

for (let j = 1; j <= optionsLength; j++) {
  let optionValue = window.currentVariant[`option${j}`];
  let noteContainer = bundleImageContainer.querySelector(`.variant-option--note--${j}`);
  
  if (noteContainer) {
    let matchedNote = matchedVariant ? variantNotes.find(note => note.variant_id == matchedVariant.id) : null;
    if (matchedNote && matchedNote.variant_note) {
      noteContainer.textContent = matchedNote.variant_note;
    } else {
      noteContainer.textContent = "";
    }
  }
}
}
}


window.updateShowMoreForMobile = function() {
const details = document.querySelectorAll("details");

for (const el of details) {  
const showMoreBtn = el.querySelector("show-more-button .label-show-more");
const showLessBtn = el.querySelector("show-more-button .label-show-less");

if (showMoreBtn) showMoreBtn.classList.remove("hidden");
if (showLessBtn) showLessBtn.classList.add("hidden");

const checked = el.querySelector("input:checked");
if (!checked) continue;

const li = checked.closest("li");
if (!li) continue;

const isHidden = li.classList.contains("hidden");

if (isHidden) {
  const button = el.querySelector("show-more-button button");
  if (button) {
    const clickEvent = new Event("click", { bubbles: true });
    button.dispatchEvent(clickEvent);
  }
}
}
}

// Desktop collapsible filters: HIDE / SHOW FILTERS toggle the sidebar via a
// class on the .facets-vertical flex wrapper (desktop-only in CSS, so the
// mobile Filter drawer is never affected). Filters start collapsed by default.
document.addEventListener('click', function(event) {
  const hideBtn = event.target.closest('.hide-filter-button');
  const showBtn = event.target.closest('.show-filter-button');
  if (!hideBtn && !showBtn) return;
  const layout = document.querySelector('.facets-vertical');
  const showFiltersBtn = document.querySelector('.show-filter-button');
  if (!layout) return;
  if (hideBtn) {
    layout.classList.add('filters-collapsed');
    if (showFiltersBtn) showFiltersBtn.classList.remove('hidden');
  } else {
    layout.classList.remove('filters-collapsed');
    if (showFiltersBtn) showFiltersBtn.classList.add('hidden');
  }
});

document.addEventListener('click', function(event) {
if (event.target.matches('.filter-button-mobile')) {
event.preventDefault();
const summary = document.querySelector('.main__filter--button');
const scrollY = window.scrollY;
const preventScrollJump = () => {
  requestAnimationFrame(() => {
    window.scrollTo({ top: scrollY, behavior: 'instant' });
  });
};
const handleClick = (e) => {
  e.preventDefault();
  summary.removeEventListener('click', handleClick);
  summary.dispatchEvent(new MouseEvent('click', {
    bubbles: true,
    cancelable: true,
    view: window
  }));
  preventScrollJump();
};
summary.addEventListener('click', handleClick);
summary.click();
}
});


/*================= Countdown announcement bar =================*/
const updateCountdown = () => {
const now = new Date();
const pstOffset = -7 * 60;
const utcNow = now.getTime() + now.getTimezoneOffset() * 60000;
const pstNow = new Date(utcNow + pstOffset * 60000);

const targetTime = new Date(pstNow);
targetTime.setHours(16, 0, 0, 0);

if (pstNow.getHours() >= 16) {
targetTime.setDate(targetTime.getDate() + 1);
}

const distance = targetTime - pstNow;

const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
const seconds = Math.floor((distance % (1000 * 60)) / 1000);

if (pstNow.getHours() >= 16) {
if(document.querySelector(".countdown__wrapper")){
  document.querySelector(".countdown__wrapper").innerHTML = "Order before tomorrow 4 PM for FREE Shipping on Orders $100+";
  document.querySelector(".announcement-bar__message").classList.add('timer__not--started');
}
if(document.querySelector(".countdown-timer")){
  document.querySelector(".countdown-timer").classList.add('no_extra_text');
}
} else if (pstNow.getHours() < 16 && pstNow.getHours() >= 0) {
if(document.getElementById("hours")){
  document.getElementById("hours").textContent = hours < 10 ? "0" + hours : hours;
}
if(document.getElementById("minutes")){
  document.getElementById("minutes").textContent = minutes < 10 ? "0" + minutes : minutes;
}
if(document.getElementById("seconds")){
  document.getElementById("seconds").textContent = seconds < 10 ? "0" + seconds : seconds;
}
} else {
if(document.getElementById("hours")){
  document.getElementById("hours").textContent = hours < 10 ? "0" + hours : hours;
}
if(document.getElementById("minutes")){
  document.getElementById("minutes").textContent = minutes < 10 ? "0" + minutes : minutes;
}
if(document.getElementById("seconds")){
  document.getElementById("seconds").textContent = seconds < 10 ? "0" + seconds : seconds;
}
}
};
setInterval(updateCountdown, 1000);

function formatMoneyWithCurrency(cents, currency = 'USD') {
const amount = (cents / 100).toFixed(2);
const currencySymbols = {
USD: '$',
GBP: '£',
EUR: '€',
CAD: '$',
AUD: '$'
};

const symbol = currencySymbols[currency] || currency;
return symbol + amount;
}
function updateSubmitButtonPrice(priceText, compareText) {
const wrapper = document.querySelector('.product-form__submit .submit-variant-prics__wrapper');
const submitButtonPrice = wrapper?.querySelector('.selected-variant__price');
const submitButtonCompare = wrapper?.querySelector('.selected-variant__compare');
const fallbackCompare = wrapper?.dataset?.compareAt;
const resolvedCompare = compareText || fallbackCompare;
if (submitButtonPrice && priceText) {
submitButtonPrice.textContent = priceText.trim();
}
if (submitButtonCompare) {
// Parse formatted money strings (e.g. "$40.99", "$1,234.56 USD") to numbers.
const parseMoney = (str) => {
  const num = parseFloat(String(str || '').replace(/[^0-9.,]/g, '').replace(/,/g, ''));
  return isNaN(num) ? null : num;
};
const compareNum = parseMoney(resolvedCompare);
const priceNum = parseMoney(priceText);
let hasCompare =
  resolvedCompare &&
  resolvedCompare.trim() &&
  (!priceText || resolvedCompare.trim() !== priceText.trim());
// Only show the strikethrough for a genuine sale: compare must be a real
// amount greater than the current price. Prevents a null/"$0.00" compare-at
// (or compare <= price) from rendering a broken "$40.99 $0.00" strikethrough.
if (compareNum !== null && priceNum !== null) {
  hasCompare = compareNum > priceNum;
}
if (hasCompare) {
  submitButtonCompare.textContent = resolvedCompare.trim();
  submitButtonCompare.classList.remove('hidden');
} else {
  submitButtonCompare.textContent = '';
  submitButtonCompare.classList.add('hidden');
}
}
}
function applySubscriptionDiscount(priceCents, discountPercent) {
const discountFactor = 1 - discountPercent / 100;
return Math.round(priceCents * discountFactor);
}

// /*================= Buyer Consent Checkbox Script  =================*/

const subscriptionWrapper = document.querySelector(".custom-subscription--widget__wrapper.active");
const button = document.querySelector('.shopify-payment-button__button'); // Standard Buy Now
const paymentBtn = document.querySelector(".duplicate-checkout-button"); // Custom Buy Now
let consentEl = document.getElementById("shopify-buyer-consent");

// Toggle button visibility
// if (subscriptionWrapper) {
//   if (paymentBtn) paymentBtn.style.display = "block";
//   if (button) button.style.display = "none";
// } else {
//   if (paymentBtn) paymentBtn.style.display = "none";
//   if (button) button.style.display = "block";
//   if(consentEl) consentEl.style.display = "none";
//   return;
// }

// Show error
function showError() {
let errorMsg = document.querySelector(".consent-error-global");
consentEl = document.getElementById("shopify-buyer-consent");
if (!consentEl) return;
if (!errorMsg) {
errorMsg = document.createElement("div");
errorMsg.textContent = "You must accept the terms to proceed";
errorMsg.classList.add("consent-error-global");
consentEl.appendChild(errorMsg);
}
consentEl.classList.add("has-error");
}

// Remove error
function removeError() {
const existingError = document.querySelector(".consent-error-global");
consentEl = document.getElementById("shopify-buyer-consent");
if (existingError) existingError.remove();
if (consentEl) consentEl.classList.remove("has-error");
}

// Function to block if unchecked
function blockIfUnchecked(e) {
let checkbox = document.getElementById("buyer-consent-checkbox");
consentEl = document.getElementById("shopify-buyer-consent");
if (checkbox && !checkbox.checked) {
e.preventDefault();
e.stopImmediatePropagation();
showError(consentEl);
return false;
} else {
removeError(consentEl);
const buyNowBtn = e.target.closest && e.target.closest(".duplicate-checkout-button");
if (buyNowBtn) {
  e.preventDefault();
  e.stopImmediatePropagation();
  const form = buyNowBtn.closest('form');
  const variantInput = form && form.querySelector('input[name="id"]');
  const variantId = variantInput && variantInput.value;

  // The Awesome Quantity bundle widget keeps the selected tier in its own state
  // and never writes it into the product form -- the form carries no quantity
  // field at all. So the native Buy-it-now would always check out ONE unit at
  // full price regardless of which tier the customer picked. Read the tier off
  // the widget and use a cart permalink instead: it lands straight on checkout
  // and still receives the quantity-based discount, because that discount is a
  // Shopify Function keyed on quantity rather than on the app's line-item
  // property (verified: /cart/<id>:2 gives $229.98 -> $195.50, identical to
  // what the app's own add-to-cart produces).
  const selectedTier = document.querySelector('.awesome-quantity-row-container.as-is-selected');
  let tierQty = 0;
  if (selectedTier) {
    const tierLabel = selectedTier.querySelector('.awesome-quantity-row-label');
    const tierMatch = tierLabel && (tierLabel.textContent || '').match(/(\d+)/);
    if (tierMatch) tierQty = parseInt(tierMatch[1], 10);
  }
  const sellingPlanInput = form && form.querySelector('input[name="selling_plan"]');
  const sellingPlan = sellingPlanInput && sellingPlanInput.value;
  // Subscription selected: cart permalinks drop the selling plan, so add the
  // line (with plan + tier quantity) via the cart API and go to checkout.
  if (variantId && sellingPlan) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: tierQty > 1 ? tierQty : 1, selling_plan: Number(sellingPlan) }] })
    }).then(function () { window.location.href = '/checkout'; })
      .catch(function () { window.location.href = '/cart'; });
    return;
  }
  if (variantId && tierQty > 1) {
    window.location.href = '/cart/' + variantId + ':' + tierQty;
    return;
  }

  // Shopify's own unbranded Buy-it-now only -- never a branded wallet button
  // (G Pay/Apple Pay), and never this duplicate, which merely borrows the
  // --unbranded modifier class for styling.
  const dynamicBtn = document.querySelector('.product-form__buttons .shopify-payment-button__button--unbranded:not(.duplicate-checkout-button):not([data-govx-href])');
  if (dynamicBtn) {
    dynamicBtn.click();
    return;
  }
  const qtyInput = form && form.querySelector('input[name="quantity"]');
  const quantity = (qtyInput && parseInt(qtyInput.value, 10)) || 1;
  if (variantId) {
    window.location.href = '/cart/' + variantId + ':' + quantity;
  }
}
}
}

// Delegated on document (capture) rather than bound to the nodes directly.
// Previously this was wrapped in `if (consentEl)`, but #shopify-buyer-consent
// is injected at runtime by the Loop subscription widget and is rendered by no
// template -- so on every non-subscription product consentEl was null, BUY IT
// NOW got no click handler at all, and clicking it did nothing. Delegation also
// survives the buy-buttons block being re-rendered by a variant change or the
// quantity-break app, which would otherwise detach a directly-bound listener.
document.addEventListener("click", function (e) {
if (!e.target || !e.target.closest) return;
if (e.target.closest(".product-form__submit, .duplicate-checkout-button")) {
  blockIfUnchecked(e);
}
}, true);
window.createConsentCheckbox = () => {
window.removeConsentCheckbox();
let checkbox = document.getElementById("buyer-consent-checkbox");
consentEl = document.getElementById("shopify-buyer-consent");
if (!checkbox) {
checkbox = document.createElement("input");
checkbox.type = "checkbox";
checkbox.id = "buyer-consent-checkbox";
checkbox.name = "buyer-consent-checkbox";
consentEl.prepend(checkbox);
checkbox.checked = window.consent;
}
// Remove error instantly when checkbox changes
checkbox.addEventListener("change", function () {
if (checkbox.checked) {
  removeError(consentEl);
}
});
[checkbox, consentEl].forEach(trigger => {
trigger.addEventListener("click", function (e) {
  if (checkbox.checked) {
    window.consent = false;
    checkbox.checked = false;
  } else {
    checkbox.checked = true;
    window.consent = true
    removeError(consentEl);
  }
});
});
if(consentEl) consentEl.style.display = "inline-block"; consentEl.classList.remove("hidden")
}
window.removeConsentCheckbox = () => {
let checkbox = document.getElementById("buyer-consent-checkbox");
consentEl = document.getElementById("shopify-buyer-consent");
if (checkbox) {
checkbox.remove();
}
if(consentEl) {
consentEl.style.display = "none";
consentEl.classList.remove("has-error");
}
}
window.handleSubscriptionToggle = () => {
  try {
    const isChecked = document.getElementById("subscriptionToggleSwitch").checked;
    const subscriptionOption = document.querySelector('[data-name="Subscribe & Save"]') || document.querySelector('[data-name="Subscribe and Save"]');
    const oneTimeOption = document.querySelector('.loop-one-time-purchase-option-radio');
    const subscriptionWrapper = document.querySelector('.custom-subscription--widget__wrapper');
    const submitButton = document.querySelector('.product-form__submit .selected-variant__price');
    const originalPriceElement = document.querySelector('.custom--subscription-group-price-amount-original');
    const subscriptionPriceElement = document.querySelector('.custom-subscription-group-price-amount');
    if(window.customClick != true) {
      if (isChecked) {
        window.createConsentCheckbox()
        if (subscriptionOption) {
          subscriptionOption.click();
        } else {
          console.warn("Subscription option not found.");
        }
        subscriptionWrapper?.classList.add('active');
        if (submitButton && subscriptionPriceElement) {
          submitButton.textContent = subscriptionPriceElement.textContent.trim();
        }
      } else {
        window.removeConsentCheckbox()
        if (oneTimeOption) {
          oneTimeOption.click();
        } else {
          console.warn("One-time purchase option not found.");
        }
        subscriptionWrapper?.classList.remove('active');
        const fallbackPrice = subscriptionPriceElement?.getAttribute('data-total-discount-price');
        updateSubmitButtonPrice(fallbackPrice || originalPriceElement?.textContent);
      }
    }
  } catch (error) {
    console.error("Error in subscription toggle handler:", error);
  }
}
document.getElementById("subscriptionToggleSwitch")?.addEventListener("change", function() {
  window.handleSubscriptionToggle();
});
window.addEventListener("DOMContentLoaded", function () {
const toggle = document.getElementById("subscriptionToggleSwitch");
const subscriptionWrapper = document.querySelector('.custom-subscription--widget__wrapper');
if (toggle?.checked && window.customClick != true) {
subscriptionWrapper?.classList.add('active');
}
if(document.querySelector("#shopify-subscription-policy-button")) {
document.querySelector("#shopify-subscription-policy-button").addEventListener("click", function () {
  setTimeout(() => {
    document.querySelectorAll(`top-level-modal[title="Cancellation policy"]`).forEach((popup, index) => {
      if(index > 0) {
        popup.remove();
      }
    })
  }, 250)
})
}
});
window.AWESOME_QUANTITY_BREAK_SELECT_ROW = (_quantity, _currentRow, _variants) => {
const discountElement = document.querySelector('.subscription--discount[data-discount]');
const subscriptionToggle = document.getElementById("subscriptionToggleSwitch");
const isSubscriptionChecked = subscriptionToggle?.checked;
const discountValue = discountElement ? parseFloat(discountElement.getAttribute('data-discount')) || 0 : 0;
const discountedPrice = applySubscriptionDiscount((_currentRow.price_original_each * _quantity), discountValue);
const subscribeAndSaveOriginalPrice = formatMoneyWithCurrency(_currentRow.total_original_price, Shopify.currency.active);
const subscribeAndSavePrice = formatMoneyWithCurrency(discountedPrice, Shopify.currency.active);
const subscriptionPriceElement = document.querySelector('.custom-subscription-group-price-amount');
const originalPriceElement = document.querySelector('.custom--subscription-group-price-amount-original');
var finalQuantityPrice = formatMoneyWithCurrency(_currentRow.total_discount_price, Shopify.currency.active);
if(subscriptionPriceElement){
subscriptionPriceElement.textContent = subscribeAndSavePrice;
subscriptionPriceElement.setAttribute('data-total-discount-price',  finalQuantityPrice);
}
if(originalPriceElement){
if(originalPriceElement && _quantity > 1){
  originalPriceElement.textContent = subscribeAndSaveOriginalPrice;
}else{
  originalPriceElement.textContent = '';
}
}
if (isSubscriptionChecked && subscriptionPriceElement) {
updateSubmitButtonPrice(
  subscriptionPriceElement.textContent,
  originalPriceElement?.textContent
);
} else {
updateSubmitButtonPrice(finalQuantityPrice, originalPriceElement?.textContent);
}
};

/*================= GTAG - select_item - Event Trigger =================*/
document.addEventListener("click", function(e) {
const anchor = e.target.closest(".card-wrapper.product-card-wrapper a, .card-wrapper.product-card-wrapper [role='link']");

if (!anchor) return;

const card = anchor.closest(".card-wrapper.product-card-wrapper");
if (!card) {
console.error("Could not find product card for clicked link.");
return;
}

const isAnchorTag = anchor.tagName === "A";
const url =
  (isAnchorTag && anchor.href) ||
  anchor.getAttribute("href") ||
  anchor.dataset?.href ||
  anchor.dataset?.url;

if (!url) return;

const isNewTabIntent =
  (isAnchorTag && anchor.getAttribute("target") === "_blank") ||
  e.metaKey ||
  e.ctrlKey ||
  e.shiftKey ||
  e.altKey ||
  e.button === 1;

const d = card.dataset;
if (!d.item_id || !d.item_name || !d.price) {
console.error("Product card is missing `item_id`, `item_name`, or `price` in data-* attributes.", d);
return;
}

if (typeof gtag === "function") {
try {
  gtag("event", "select_item", {
    send_to: "G-37PQBK0M38",
    items: [
      {
        item_id: `${d.item_id}`,
        item_name: `${d.item_name}`,
        price: `${d.price}`
      }
    ]
  });
} catch (err) {
  // console.error("Error sending event to gtag:", err);
}
} else {
// console.error("gtag is not defined on the page.");
}

// Respect normal browser behavior for real <a> tags when opening in a new tab.
if (isAnchorTag && isNewTabIntent) return;

// For non-<a> [role="link"] elements, emulate expected behavior.
e.preventDefault();
if (!isAnchorTag && isNewTabIntent) {
  window.open(url, "_blank", "noopener,noreferrer");
  return;
}

window.location.href = `${url}`

});

window.addEventListener('DOMContentLoaded', () => {
  // window.handleSubscriptionToggle();
  document.querySelectorAll(".atc-initially-disabled").forEach(button => {
    button.classList.remove("atc-initially-disabled");
  })
});

// Loop auto-subscribe interval retired Sep 2026 (subscriptions moved to Seal, see snippets/seal-purchase-options.liquid).
